import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelRadio as _vModelRadio, resolveComponent as _resolveComponent, createBlock as _createBlock, withModifiers as _withModifiers, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4a1677a8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "add-edit-accounting-software" }
const _hoisted_2 = { class: "heading-text" }
const _hoisted_3 = { class: "line1" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "line2" }, "Accounting Software", -1))
const _hoisted_5 = { class: "body-main" }
const _hoisted_6 = { class: "ls-form" }
const _hoisted_7 = { class: "input-box-1" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Name of accounting software *", -1))
const _hoisted_9 = {
  key: 0,
  class: "validation-msg"
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fal fa-exclamation-circle" }, null, -1))
const _hoisted_11 = { class: "radio-buttons" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Status", -1))
const _hoisted_13 = { style: {"display":"flex"} }
const _hoisted_14 = { style: {"float":"left"} }
const _hoisted_15 = { class: "radio" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "radio-elmt" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "radio-checkmark-box" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "radio-checkmark" })
  ]),
  /*#__PURE__*/_createElementVNode("span", { class: "radio-text" }, "Active")
], -1))
const _hoisted_17 = {
  class: "ml-4",
  style: {"float":"left"}
}
const _hoisted_18 = { class: "radio" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "radio-elmt" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "radio-checkmark-box" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "radio-checkmark" })
  ]),
  /*#__PURE__*/_createElementVNode("span", { class: "radio-text" }, "Inactive")
], -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_21 = { class: "radio-buttons" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Show in ATCS", -1))
const _hoisted_23 = { style: {"display":"flex"} }
const _hoisted_24 = { style: {"float":"left"} }
const _hoisted_25 = { class: "radio" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "radio-elmt" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "radio-checkmark-box" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "radio-checkmark" })
  ]),
  /*#__PURE__*/_createElementVNode("span", { class: "radio-text" }, "Yes")
], -1))
const _hoisted_27 = {
  class: "ml-4",
  style: {"float":"left"}
}
const _hoisted_28 = { class: "radio" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "radio-elmt" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "radio-checkmark-box" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "radio-checkmark" })
  ]),
  /*#__PURE__*/_createElementVNode("span", { class: "radio-text" }, "No")
], -1))
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_31 = { class: "radio-buttons" }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Certified", -1))
const _hoisted_33 = { style: {"display":"flex"} }
const _hoisted_34 = { style: {"float":"left"} }
const _hoisted_35 = { class: "radio" }
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "radio-elmt" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "radio-checkmark-box" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "radio-checkmark" })
  ]),
  /*#__PURE__*/_createElementVNode("span", { class: "radio-text" }, "Trust")
], -1))
const _hoisted_37 = {
  class: "ml-4",
  style: {"float":"left"}
}
const _hoisted_38 = { class: "radio" }
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "radio-elmt" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "radio-checkmark-box" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "radio-checkmark" })
  ]),
  /*#__PURE__*/_createElementVNode("span", { class: "radio-text" }, "General")
], -1))
const _hoisted_40 = {
  class: "ml-4",
  style: {"float":"left"}
}
const _hoisted_41 = { class: "radio" }
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "radio-elmt" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "radio-checkmark-box" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "radio-checkmark" })
  ]),
  /*#__PURE__*/_createElementVNode("span", { class: "radio-text" }, "Both")
], -1))
const _hoisted_43 = {
  key: 0,
  class: "validation-msg"
}
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fal fa-exclamation-circle" }, null, -1))
const _hoisted_45 = { class: "controls" }
const _hoisted_46 = ["disabled"]
const _hoisted_47 = ["disabled"]
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("i", { class: "fal fa-angle-right" })
], -1))

export function render(_ctx, _cache) {
  const _component_LoadingIndicator = _resolveComponent("LoadingIndicator")
  const _component_ModalBox = _resolveComponent("ModalBox")

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createVNode(_component_ModalBox, {
      onClose: _cache[10] || (_cache[10] = $event => (_ctx.closeModal()))
    }, {
      "header-text": _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("span", _hoisted_3, _toDisplayString(!_ctx.editMode ? 'Add new accounting software' : 'Edit ' + _ctx.accountingApp.name), 1),
          _hoisted_4
        ])
      ]),
      body: _withCtx(() => [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("form", _hoisted_6, [
            _createElementVNode("fieldset", _hoisted_7, [
              _hoisted_8,
              _withDirectives(_createElementVNode("input", {
                type: "text",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => ((_ctx.formData.name) = $event)),
                maxlength: "200"
              }, null, 512), [
                [_vModelText, _ctx.formData.name]
              ]),
              _createElementVNode("div", {
                class: _normalizeClass(["footnote", [ _ctx.formData.name.length === 200 ? 'full' : '']])
              }, _toDisplayString(_ctx.formData.name.length) + "/200 characters ", 3),
              (_ctx.formData.name === '')
                ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                    _hoisted_10,
                    _createTextVNode(" Mandatory field ")
                  ]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("fieldset", _hoisted_11, [
              _hoisted_12,
              _createElementVNode("div", _hoisted_13, [
                _createElementVNode("div", _hoisted_14, [
                  _createElementVNode("label", _hoisted_15, [
                    _withDirectives(_createElementVNode("input", {
                      type: "radio",
                      name: "status",
                      value: 1,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => ((_ctx.status) = $event))
                    }, null, 512), [
                      [_vModelRadio, _ctx.status]
                    ]),
                    _hoisted_16
                  ])
                ]),
                _createElementVNode("div", _hoisted_17, [
                  _createElementVNode("label", _hoisted_18, [
                    _withDirectives(_createElementVNode("input", {
                      type: "radio",
                      name: "status",
                      value: 2,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => ((_ctx.status) = $event))
                    }, null, 512), [
                      [_vModelRadio, _ctx.status]
                    ]),
                    _hoisted_19
                  ])
                ])
              ])
            ]),
            _hoisted_20,
            _createElementVNode("fieldset", _hoisted_21, [
              _hoisted_22,
              _createElementVNode("div", _hoisted_23, [
                _createElementVNode("div", _hoisted_24, [
                  _createElementVNode("label", _hoisted_25, [
                    _withDirectives(_createElementVNode("input", {
                      type: "radio",
                      name: "isShowInAtcs",
                      value: true,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => ((_ctx.isShowInAtcs) = $event))
                    }, null, 512), [
                      [_vModelRadio, _ctx.isShowInAtcs]
                    ]),
                    _hoisted_26
                  ])
                ]),
                _createElementVNode("div", _hoisted_27, [
                  _createElementVNode("label", _hoisted_28, [
                    _withDirectives(_createElementVNode("input", {
                      type: "radio",
                      name: "isShowInAtcs",
                      value: false,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => ((_ctx.isShowInAtcs) = $event))
                    }, null, 512), [
                      [_vModelRadio, _ctx.isShowInAtcs]
                    ]),
                    _hoisted_29
                  ])
                ])
              ])
            ]),
            _hoisted_30,
            _createElementVNode("fieldset", _hoisted_31, [
              _hoisted_32,
              _createElementVNode("div", _hoisted_33, [
                _createElementVNode("div", _hoisted_34, [
                  _createElementVNode("label", _hoisted_35, [
                    _withDirectives(_createElementVNode("input", {
                      type: "radio",
                      name: "certified",
                      value: 1,
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => ((_ctx.certified) = $event))
                    }, null, 512), [
                      [_vModelRadio, _ctx.certified]
                    ]),
                    _hoisted_36
                  ])
                ]),
                _createElementVNode("div", _hoisted_37, [
                  _createElementVNode("label", _hoisted_38, [
                    _withDirectives(_createElementVNode("input", {
                      type: "radio",
                      name: "certified",
                      value: 2,
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => ((_ctx.certified) = $event))
                    }, null, 512), [
                      [_vModelRadio, _ctx.certified]
                    ]),
                    _hoisted_39
                  ])
                ]),
                _createElementVNode("div", _hoisted_40, [
                  _createElementVNode("label", _hoisted_41, [
                    _withDirectives(_createElementVNode("input", {
                      type: "radio",
                      name: "certified",
                      value: 3,
                      "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => ((_ctx.certified) = $event))
                    }, null, 512), [
                      [_vModelRadio, _ctx.certified]
                    ]),
                    _hoisted_42
                  ])
                ])
              ]),
              (!_ctx.certified)
                ? (_openBlock(), _createElementBlock("div", _hoisted_43, [
                    _hoisted_44,
                    _createTextVNode(" Mandatory field ")
                  ]))
                : _createCommentVNode("", true)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_45, [
          (_ctx.submitting)
            ? (_openBlock(), _createBlock(_component_LoadingIndicator, {
                key: 0,
                class: "loading-indicator",
                showLoadingText: false
              }))
            : _createCommentVNode("", true),
          _createElementVNode("button", {
            class: "btn btn-default",
            disabled: _ctx.submitting,
            onClick: _cache[8] || (_cache[8] = _withModifiers($event => (_ctx.closeModal()), ["prevent","stop"]))
          }, "Back", 8, _hoisted_46),
          _createElementVNode("button", {
            class: "btn btn-primary",
            disabled: _ctx.submitting || !_ctx.isFormDirty,
            onClick: _cache[9] || (_cache[9] = _withModifiers((...args) => (_ctx.saveAccountingSoftware && _ctx.saveAccountingSoftware(...args)), ["prevent","stop"]))
          }, [
            _createTextVNode(_toDisplayString(!_ctx.editMode ? 'Add' : 'Save changes'), 1),
            _hoisted_48
          ], 8, _hoisted_47)
        ])
      ]),
      _: 1
    })
  ]))
}